<template>
  <div class="container">
    <!-- <div class="select">
      <form action="/">
        <van-search
          background="#fff"
          @click="$router.replace('/appointment/home/select')"
          clearable
          placeholder="搜索旅行社名称或景区名称"
        />
      </form>
    </div> -->
    <div class="select">
      <div class="searchBox">
        <img src="../../../../assets/image/sousuo_ic_daoyou @2x (1).png"/>
        <input type="text" v-model="name" :placeholder="searchPlaceHolder" @click="goSelect()" />
      </div>
    </div>
    <div class="position">
      <van-index-bar highlight-color="#36B374" :sticky-offset-top="60" :index-list="indexList">
        <div v-for="(item, ind) in list" :key="ind">
          <van-index-anchor :index="item.initials" />
          <cell v-for="(it, index) in item.children" @click="goScoreDetails(it)" :key="index" :title="it.name" />
        </div>
      </van-index-bar>
    </div>
  </div>
</template>
<script>
import appointment from "@/service/modules/appointment";
export default {
  data() {
    return {
      list: [],
      indexList: [],
      name : '',
      areaCode: '',
      searchType: 1,
      searchPlaceHolder: '搜索旅行社名称或景区名称',
      appointmentType: this.$route.query.appointmentType || "team",
    };
  },
  created() {
    this.areaCode = JSON.parse(localStorage.getItem("auth")).areaCode;
    this.searchType = this.$route.query.searchType;
    if (this.searchType === 2) {
      this.searchPlaceHolder = '搜索景区名称';
    }
    this.list = [
    ];
    this.queryOrgAndTravelAgencyList();
  },
  computed: {
  },
  methods: {
    // 获取检索接口数据
    queryOrgAndTravelAgencyList() {
      let params = {
        areaCode: this.areaCode
      }
      appointment.queryOrgAndTravelAgencyList(params).then(res => {
        let arr = [];
        // 如果是散客预约点进来，过滤掉旅行社只留景区
        if (this.searchType === 2) {
          res.data.map((item) => {
            if (item.type === '景区') {
              arr.push(item);
            }
          })
          this.dealData(arr);
        } else {
          this.dealData(res.data);
        }
      });
    },
    // 处理数据
    dealData(data) {
      let dataList = []; // 字母数组
      let arr = [];
      // 遍历出所有的字母
      data.forEach((value, key) => {
        if (dataList.indexOf(value.initials) < 0) {
          dataList.push(value.initials);
          arr.push({
            initials: value.initials,
            children: []
          });
        }
      });
      this.dealMore(data,dataList,arr)
    },
    dealMore(data, dataList, arr) {
      this.indexList = dataList;
      let index
      for(let i=0;i<data.length;i++) {
        index = dataList.indexOf(data[i].initials)
        arr[index].children.push({
          name: data[i].name,
           id: data[i].id,
          type: data[i].type
        })
      }
      this.list = arr;
    },
    goScoreDetails(e) {
      console.log(this.appointmentType);
      this.$router.replace({
        path: '/appointment/home/list',
        query: {
          orgId: e.type === '景区' ? e.id : '',
          travelId: e.type === '旅行社' ? e.id : '',
          scenicName: e.type === '景区' ? e.name : '',
          travelName: e.type === '旅行社' ? e.name : '',
          appointmentType: this.appointmentType
        }
      })
    },
    goSelect() {
      this.$router.replace({
        path: '/appointment/home/select',
        query: {
          searchType: this.searchType,
          appointmentType: this.appointmentType
        }
      })
    }
    // watch: {
    //   list() {
    //     setTimeout(() => {
    //       this._calculateHeight();
    //     }, 20);
    //   },
    //   scrollY(newY) {
    //     const listHeight = this.listHeight;
    //     // console.log(listHeight);
    //     // 当滚动到顶部，newY>0
    //     if (newY > 0) {
    //       this.currentIndex = 0;
    //       return;
    //     }
    //     // 在中间部分滚动
    //     for (let i = 0; i < listHeight.length - 1; i++) {
    //       let height1 = listHeight[i];
    //       let height2 = listHeight[i + 1];
    //       if (-newY >= height1 && -newY < height2) {
    //         this.currentIndex = i;
    //         this.diff = height2 + newY;
    //         return;
    //       }
    //     }
    //     // 当滚动到底部，且-newY大于最后一个元素的上限
    //     this.currentIndex = listHeight.length - 2;
    //     console.log("ceshi" + this.currentIndex);
    //   },
    //   diff(newVal) {
    //     let fixedTop =
    //       newVal > 0 && newVal < TITLE_HEIGHT ? newVal - TITLE_HEIGHT : 0;
    //     if (this.fixedTop === fixedTop) {
    //       return;
    //     }
    //     this.fixedTop = fixedTop;
    //     this.$refs.fixed.style.transform = `translate3d(0,${fixedTop}px,0)`;
    //   }
    // }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  // position: relative;
  .box_container1 {
    width: 100%;
    position: fixed;
    top: 20px;
    bottom: 0;
    .wrapper {
      width: 100%;
      .box {
        width: 100%;
        .item {
          width: 100%;
          h4 {
            width: 100%;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            background-color: #f9f9f9;
            padding: 0 16px;
            box-sizing: border-box;
          }
          ul {
            width: 100%;
            padding: 16px 0;
            .item_list {
              width: 100%;
              font-size: 14px;
              margin-top: 16px;
              padding: 0 16px;
              box-sizing: border-box;
            }

            .item_list:nth-child(1) {
              margin-top: 0;
            }
          }
        }
      }
    }
  }
  .list-shortcut {
    position: absolute;
    z-index: 30;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    padding: 20px 0;
    border-radius: 10px;
    text-align: center;
    background: #efefef;
    // font-family: Helvetica;
    .short_item {
      padding: 5px 0;
      color: #999999;
      font-size: 13px;
    }
    .active {
      color: red !important;
    }
  }
  .list-fixed {
    position: absolute;
    left: 0;
    top: 70px;
    width: 100%;
    height: 30px;
    background: #f9f9f9;
    z-index: 20;
    .fixed-title {
      box-sizing: border-box;
      padding-left: 16px;
      font-size: 14px;
      width: 100%;
      line-height: 30px;
    }
  }
}
.select {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  // line-height: 60px;
  background: #fff;
  z-index: 999;
}
.searchBox {
      height: 36px;
      line-height: 36px;
      margin: 12px 16px 0 16px;
      background-color: #fff;
      border: 1px solid #eee;
      border-radius: 3px;
      box-sizing: border-box;
      position: relative;
      font-size: 14px;

      > img {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 10px;
        left: 14px;
      }

      > input {
        font-family: PingFang SC;
        width: 100%;
        height: 28px;
        line-height: 28px;
        padding: 0 16px 0 40px;
        box-sizing: border-box;
        border-radius: 2px;
        background-color: #fff;
      }
      input::-webkit-input-placeholder {
        color: #999999;
      }
      input::-moz-input-placeholder {
        color: #999999;
      }
      input::-ms-input-placeholder {
        color: #999999;
      }
    }
.select ::v-deep .van-search__content {
  height: 34px;
  background-color: #fff;
  border: 1px solid #eee;
}
.van-search {
  padding: 12px 16px;
  box-sizing: border-box;
}
.position {
  margin-top: 68px;
}
.position ::v-deep .van-index-anchor {
  background-color: #f9f9f9;
}
/deep/.position .van-cell:last-child {
  margin-bottom: 16px;
}
/deep/.position .van-cell:nth-child(1) {
  margin-top: 10px !important;
}
/deep/.van-cell__title {
  font-weight:400;
  font-size: 14px;
  color: #333;;
}
/deep/ .van-cell {
  padding-top: 6px ;
  padding-bottom: 6px;
}
/deep/ .van-cell:last-child {
  margin-bottom: 10px !important;
}
/deep/.position .van-cell:not(:last-child)::after {
  border-bottom: 0.026667rem solid #fff;
}
/deep/.van-index-anchor {
  margin-bottom: 10px;
  color: #999 !important;
  font-size: 14px;
  font-weight:400;
}
/deep/.van-index-bar__index {
  height: 20px;
  line-height: 20px;
  color: #999;
  font-size: 12px;
  font-weight:400;
}
/deep/.van-index-bar__sidebar {
  margin-right: 8px;
}

</style>
